<div class="lib-notifications" role="presentation">
  <button
    type="button"
    class="lib-notifications-trigger"
    [class.lib-notifications-trigger-light]="appType === 'clinic' && iconColor === 'light'"
    [class.lib-notifications-trigger--active]="isNotificationsOpen"
    [class.lib-notifications-trigger--account]="appType === 'account' || appType === 'lab'"
    (click)="toggleNotifications()"
    [attr.aria-expanded]="isNotificationsOpen"
    [attr.aria-label]="'NOTIFICATIONS.TITLE' | translate"
  >
    @if (appType === 'account' || appType === 'lab') {
      <svg lucideBell class="lib-notifications-icon lib-notifications-icon--lucide" [size]="16" [strokeWidth]="2"></svg>
    } @else {
      <span class="material-icons lib-notifications-icon lib-notifications-icon--outline">notifications_none</span>
      <span class="material-icons lib-notifications-icon lib-notifications-icon--filled">notifications</span>
    }
    @if (unreadNotificationCount > 0) {
    <span
      class="lib-notifications-badge"
      [class.lib-notifications-badge--overflow]="unreadNotificationCount > (appType === 'clinic' ? 99 : 9)"
    >{{ notificationBadgeText }}</span>
    }
  </button>

  @if (isNotificationsOpen && usesDentcamNotify()) {
  <div
    class="lib-notifications-panel notify-popover"
    role="dialog"
    [attr.aria-label]="'NOTIFICATIONS.TITLE' | translate"
  >
    <ng-container *ngTemplateOutlet="accountNotifyHeader" />
    <ng-container *ngTemplateOutlet="accountNotifyControls" />
    <div class="notify-popover-body">
      @if (accountPreviewNotifications.length) {
      <div class="notify-stream notify-stream--cards">
        @for (notif of accountPreviewNotifications; track notif.id) {
        <ng-container *ngTemplateOutlet="accountNotifyRow; context: { $implicit: notif }" />
        }
      </div>
      } @else {
      <div class="notify-empty">
        <p>{{ 'NOTIFICATIONS.NO_NEW_NOTIFICATIONS' | translate }}</p>
      </div>
      }
    </div>
    <div class="notify-footer">
      <button type="button" class="notify-footer-action" (click)="openAllNotifications()">
        {{ 'NOTIFICATIONS.VIEW_ALL' | translate }}
      </button>
    </div>
  </div>
  }

  @if (isNotificationsOpen && appType === 'clinic') {
  <div
    class="lib-notifications-dropdown"
    role="dialog"
    [attr.aria-label]="'NOTIFICATIONS.TITLE' | translate"
    animate.enter="dc-dropdown-enter"
    animate.leave="dc-dropdown-leave"
  >
    <div class="lib-notifications-header">
      <div class="lib-notifications-header-main">
        <h3>{{ 'NOTIFICATIONS.TITLE' | translate }}</h3>
        @if (allNotificationFilter; as allFilter) {
        <button
          type="button"
          class="lib-notifications-filter-btn"
          [class.active]="activeNotificationFilter === allFilter.value"
          (click)="setNotificationFilter(allFilter)"
        >
          {{ allFilter.label | translate }}
        </button>
        }
      </div>
      <button
        type="button"
        class="lib-notifications-mark-read"
        (click)="markAllAsRead()"
      >
        {{ 'NOTIFICATIONS.MARK_ALL_READ' | translate }}
      </button>
    </div>

    <div class="lib-notifications-filters">
      @for (filter of secondaryNotificationFilters; track filter.value) {
      <button
        type="button"
        class="lib-notifications-filter-btn"
        [class.active]="activeNotificationFilter === filter.value"
        (click)="setNotificationFilter(filter)"
      >
        {{ filter.label | translate }}
      </button>
      }
    </div>

    <div
      class="lib-notifications-list"
      [class.expanded]="isNotificationsExpanded"
    >
      @for (notif of displayedNotifications; track notif.id) {
      <div
        class="lib-notification-item"
        [class.unread]="notif.unread"
        (click)="onNotificationClick(notif)"
        tabindex="0"
        (keydown.enter)="onNotificationClick(notif)"
      >
        <div class="lib-notification-icon" [attr.data-type]="notif.subType">
          <span class="material-icons">{{ notif.icon }}</span>
        </div>
        <div class="lib-notification-content">
          <p class="lib-notification-title">{{ notif.title }}</p>
          <p class="lib-notification-desc">{{ notif.description }}</p>
          <p class="lib-notification-time">{{ notif.time }}</p>
        </div>
        @if (notif.unread) {
        <div class="lib-notification-dot"></div>
        }
      </div>
      } @empty {
      <div class="lib-notifications-empty">
        <span class="material-icons">notifications_none</span>
        <p>{{ 'NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}</p>
      </div>
      }
    </div>

    @if (filteredNotifications.length > 5) {
    <div class="lib-notifications-footer">
      <button
        type="button"
        class="lib-notifications-more"
        (click)="toggleNotificationsExpanded()"
      >
        @if (isNotificationsExpanded) { {{ 'NOTIFICATIONS.SHOW_LESS' | translate }}
        <span class="material-icons">expand_less</span> } @else { {{ 'NOTIFICATIONS.SHOW_MORE' | translate }}
        <span class="material-icons">expand_more</span>
        }
      </button>
    </div>
    }
  </div>
  }

  @if (usesDentcamNotify() && isNotificationDrawerOpen) {
  <div class="lib-notifications-drawer-backdrop" (mousedown)="closeDrawer()">
    <aside
      class="lib-notifications-drawer"
      role="dialog"
      [attr.aria-label]="'NOTIFICATIONS.TITLE' | translate"
      (mousedown)="$event.stopPropagation()"
    >
      <div class="notify-center-toolbar">
        <button type="button" class="notify-center-close" (click)="closeDrawer()" [attr.aria-label]="'COMMON.CLOSE' | translate">
          <svg lucideX class="lucide lucide-x" [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="accountNotifyHeader" />
      <ng-container *ngTemplateOutlet="accountNotifyControls" />
      <div class="notify-center-body">
      @if (accountTodayNotifications.length || accountEarlierNotifications.length) {
        <div class="notify-stream notify-stream--grouped">
          @if (accountTodayNotifications.length) {
          <section class="notify-stream-group">
            <h3 class="notify-group-label">{{ 'NOTIFICATIONS.TODAY' | translate }}</h3>
            <div class="notify-stream notify-stream--cards">
              @for (notif of accountTodayNotifications; track notif.id) {
              <ng-container *ngTemplateOutlet="accountNotifyRow; context: { $implicit: notif }" />
              }
            </div>
          </section>
          }
          @if (accountEarlierNotifications.length) {
          <section class="notify-stream-group">
            <h3 class="notify-group-label">{{ 'NOTIFICATIONS.EARLIER' | translate }}</h3>
            <div class="notify-stream notify-stream--cards">
              @for (notif of accountEarlierNotifications; track notif.id) {
              <ng-container *ngTemplateOutlet="accountNotifyRow; context: { $implicit: notif }" />
              }
            </div>
          </section>
          }
        </div>
        } @else {
        <div class="notify-empty">
          <p>{{ 'NOTIFICATIONS.NO_NEW_NOTIFICATIONS' | translate }}</p>
        </div>
        }
      </div>
    </aside>
  </div>
  }

  <ng-template #accountNotifyHeader>
    <div class="notify-header">
      <div class="notify-header-main">
        <div class="notify-header-copy">
          <h2 class="notify-header-title">{{ 'NOTIFICATIONS.TITLE' | translate }}</h2>
        </div>
        @if (unreadNotificationCount > 0) {
        <button type="button" class="notify-text-action" (click)="markAllAsRead()">
          {{ 'NOTIFICATIONS.MARK_ALL_READ' | translate }}
        </button>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #accountNotifyControls>
    <div class="notify-controls-row">
      <div class="notify-segment" role="group" [attr.aria-label]="'NOTIFICATIONS.UNREAD' | translate">
        <button
          type="button"
          class="notify-segment-btn"
          [class.notify-segment-btn--active]="accountReadFilter === 'all'"
          [attr.aria-pressed]="accountReadFilter === 'all'"
          (click)="setAccountReadFilter('all')"
        >
          {{ 'NOTIFICATIONS.FILTERS.ALL' | translate }}
        </button>
        <button
          type="button"
          class="notify-segment-btn"
          [class.notify-segment-btn--active]="accountReadFilter === 'unread'"
          [attr.aria-pressed]="accountReadFilter === 'unread'"
          (click)="setAccountReadFilter('unread')"
        >
          {{ 'NOTIFICATIONS.UNREAD' | translate }}
        </button>
      </div>
      <div class="notify-filter-wrap">
        <button
          type="button"
          class="notify-filter-btn"
          [class.notify-filter-btn--active]="accountScopeFilter !== 'all'"
          [attr.aria-expanded]="isAccountFilterMenuOpen"
          [attr.aria-label]="'NOTIFICATIONS.FILTER_ACTIVITY' | translate"
          (click)="toggleAccountFilterMenu($event)"
        >
          <svg lucideFunnel class="lucide lucide-funnel" [size]="14" [strokeWidth]="1.75" aria-hidden="true"></svg>
        </button>
        @if (isAccountFilterMenuOpen) {
        <div class="notify-activity-menu" role="menu">
          @if (appType === 'lab') {
            @for (filter of notificationFilters; track filter.label) {
            <button
              type="button"
              class="notify-activity-item"
              [class.notify-activity-item--active]="isLabScopeActive(filter)"
              (click)="setAccountScopeFilter(filter.value)"
            >
              {{ filter.label | translate }}
            </button>
            }
          } @else {
          <button type="button" class="notify-activity-item" [class.notify-activity-item--active]="accountScopeFilter === 'all'" (click)="setAccountScopeFilter('all')">
            {{ 'NOTIFICATIONS.FILTERS.ALL' | translate }}
          </button>
          <button type="button" class="notify-activity-item" [class.notify-activity-item--active]="accountScopeFilter === 'subscription'" (click)="setAccountScopeFilter('subscription')">
            {{ 'NOTIFICATIONS.FILTERS.SUBSCRIPTIONS' | translate }}
          </button>
          <button type="button" class="notify-activity-item" [class.notify-activity-item--active]="accountScopeFilter === 'team'" (click)="setAccountScopeFilter('team')">
            {{ 'NOTIFICATIONS.FILTERS.TEAM' | translate }}
          </button>
          <button type="button" class="notify-activity-item" [class.notify-activity-item--active]="accountScopeFilter === 'system'" (click)="setAccountScopeFilter('system')">
            {{ 'NOTIFICATIONS.FILTERS.SYSTEM' | translate }}
          </button>
          }
        </div>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #accountNotifyRow let-notif>
    <div class="notify-row-wrap" [class.notify-row-wrap--unread]="notif.unread">
      <button type="button" class="notify-row" (click)="onNotificationClick(notif)">
        <span class="notify-icon-wrap" aria-hidden="true">
          @if (accountIconKind(notif) === 'users') {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" /></svg>
          } @else if (accountIconKind(notif) === 'info') {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75" /><path d="M12 11v5M12 8h.01" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" /></svg>
          } @else {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75" /><path d="M12 8v5l3 2" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" /></svg>
          }
        </span>
        <span class="notify-row-main">
          <span class="notify-row-top">
            <span class="notify-row-title" [class.notify-row-title--unread]="notif.unread">{{ notif.title }}</span>
            <span class="notify-row-meta">
              <span class="notify-row-time">{{ notif.time }}</span>
              @if (notif.unread) {
              <span class="notify-unread-dot"></span>
              }
            </span>
          </span>
          <span class="notify-row-context">{{ notif.description }}</span>
        </span>
      </button>
    </div>
  </ng-template>
</div>
